<template lang="pug">
.sv-upload(
    :class="{ 'sv-upload--loaded': preview, 'sv-upload--hovered': hovered, 'without-image': !isImage && preview }"
    @mouseover="over(true)"
    @mouseleave="over(false)"
)
    .sv-upload__label
        SvButton.sv-upload__button(
            v-if="!withRemove"
            view="shadow"
            :text="buttonLabel"
            @click="changeFile"
        )

        .sv-upload__button-container(
          v-else
        )
          SvButton.sv-upload__button-change(
            view="shadow"
            :text="buttonLabel"
            @click="changeFile"
          )

          SvButton.sv-upload__button-remove(
            view="shadow"
            icon
            :prependIcon=`{
                icon: 'trash',
                width: 24,
                height: 24,
                hover: '#1993EB',
                default: '#B7BAC6'
            }`
            @click="remove"
          )

        input.sv-upload__input(
            ref="uploadFile"
            type="file"
            @change="uploaded"
        )

        .image-wrapper-upload(
          v-if="preview && isImage"
        )
          img.sv-upload__preview(
              :src="preview"
          )
</template>

<script>
import SvButton from '@/components/uikit/SvButton.vue';

export default {
  name: 'SvUpload',

  model: {
    prop: 'preview',
    event: 'input',
  },

  data() {
    return {
      hovered: false,
    };
  },

  props: {
    preview: {
      type: String,
      default: null,
    },

    withRemove: {
      type: Boolean,
      default: false,
    },
    isImage: {
      type: Boolean,
      default: true
    }
  },

  components: {
    SvButton,
  },

  computed: {
    buttonLabel() {
      return this.preview ? 'Изменить' : 'Загрузить';
    },
  },

  methods: {
    uploaded(arg) {
      // const preview = window.URL.createObjectURL(arg.target.files[0]);
      const reader = new FileReader();
      reader.readAsDataURL(arg.target.files[0]);
      reader.onload = () => {
        this.$emit('input', reader.result);
      };
      // this.$emit('input', preview);
      this.$emit('inputedFile', arg.target.files[0]);
    },

    over(val) {
      this.hovered = val;
    },

    remove() {
      this.$emit('remove');
    },

    changeFile() {
      this.$refs.uploadFile.click();
    }
  },
};
</script>

<style lang="scss" scoped>
.sv-upload {
    position: relative;

    &.without-image {
      width: 100%;
      height: 100%;
    }

    .image-wrapper-upload {
      display: block;
      overflow: hidden;
      width: 310px;
      height: 150px;
      border-radius: 15px;
    }

    &--loaded {
        .sv-upload__container {
            position: absolute;
            top: calc(50% - 20px);
            left: calc(50% - 95px);
            width: 190px;
            display: flex;
            justify-content: center;
            opacity: 0;
        }

        .sv-upload__button-change {
            position: absolute;
            top: calc(50% - 20px);
            left: calc(50% - 95px);
            width: 140px;
            display: flex;
            justify-content: center;
            opacity: 0;
            z-index: 20;
        }

        .sv-upload__button-remove {
            position: absolute;
            top: calc(50% - 20px);
            left: calc(50% + 52px);
            width: 40px;
            display: flex;
            justify-content: center;
            opacity: 0;
            z-index: 20;
        }

        .sv-upload__button {
            position: absolute;
            top: calc(50% - 20px);
            left: calc(50% - 70px);
            width: 140px;
            display: flex;
            justify-content: center;
            opacity: 0;
            z-index: 20;
        }

        .sv-upload__label:before {
                content: '';
                // cursor: pointer;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: rgba(255, 255, 255, .7);
                z-index: -10;
        }

        &.sv-upload--hovered {
            .sv-upload__label {
                // cursor: pointer;
            }

            .sv-upload__label:before {
                // content: '';
                // position: absolute;
                // top: 0;
                // left: 0;
                // right: 0;
                // bottom: 0;
                // background-color: rgba(255, 255, 255, .7);
                z-index: 1;
            }
        }
    }

    &--hovered {
        .sv-upload__button {
            // cursor: pointer;
            transition: opacity ease-in-out .2s; // из-за него дергалась верстка

            opacity: 1;
        }

        .sv-upload__button-change,
        .sv-upload__button-remove,
        .sv-upload__container {
            transition: opacity ease-in-out .2s; // из-за него дергалась верстка

            opacity: 1;
        }
    }

    &__input {
        // opacity: 0;
        // position: absolute;
        // width: 100%;
        // height: 100%;
        // cursor: pointer;
        // top: 0;
        // left: 0;
        // right: 0;
        // bottom: 0;
        width: 0;
        display: none;
    }

    &__preview {
      max-width: 110%;
      max-height: 155%;
      min-width: 100%;
      min-height: 100%;
    }
}
</style>
